import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
    selector: '[appDragDrop]',
    standalone: false
})
export class DragDropDirective {

  @Output() files: EventEmitter<FileList> = new EventEmitter();

  @HostBinding("style.background") background = "";

  constructor(private sanitizer: DomSanitizer) { }

  @HostListener("dragover", ["$event"]) public onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.background = "#cce6ee";
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.background = "";
  }

  @HostListener('drop', ['$event']) public onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.background = '';

    if (event!.dataTransfer!.files) this.files.next(event!.dataTransfer!.files)
  }


}
